export const coPaymentTypesPathName = 'co-payment-types';
export const coPaymentDebitorRunsPathName = 'debitor-runs';
